import { forwardRef, type Ref, type SVGProps } from "react";
const IconChevronUpCircleOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M16 28a12 12 0 1 0 0-23.999A12 12 0 0 0 16 28m0 2a14 14 0 1 1 0-28 14 14 0 0 1 0 28" />
    <path d="M22.7 18.7a1 1 0 0 1-1.4 0L16 13.4l-5.3 5.3a1 1 0 0 1-1.4 0 1 1 0 0 1 0-1.4l6-6a1 1 0 0 1 1.4 0l6 6a1 1 0 0 1 0 1.4" />
  </svg>
);
const ForwardRef = forwardRef(IconChevronUpCircleOutlineSVG);
ForwardRef.displayName = "IconChevronUpCircleOutline";
export { ForwardRef as IconChevronUpCircleOutline };
